import { DefaultLayout } from "~/layouts/DefaultLayout";
import { MetaHeader } from "~/components/MetaHeader";
import { InstagramIframe } from "~/components/InstagramIframe";

const Contact: React.VFC = () => {
    return (
        <DefaultLayout>
            <>
                <MetaHeader title={"お問い合わせ - 福岡カフェ日記 | 福岡最大級のカフェメディア"} description={"福岡カフェ日記では、読者様からのご意見やご質問を大切にしています。お店の推薦、広告掲載のお問い合わせ、または当サイトの内容に関するご質問など、どのようなことでもお気軽にお問い合わせください。福岡カフェ日記は、地域コミュニティと連携を深め、より良い情報提供を目指しています。"} />
                <div className="contact">
                    <h1>お問い合わせ</h1>
                    <p>お問い合わせはインスタグラムのDMにお願いいたします。</p>
                    <div className="instagramEmbed">
                        <InstagramIframe src={"fukuoka___cafe"} />
                    </div>
                </div>
            </>

        </DefaultLayout>
    );
};

export default Contact;